import api from "./api";

export async function listCvFilesForUser(userId) {
    const res = await api.get(`/CurriculumVitae/files/${userId}`);
    return res.data;
}

export async function generateCvPdf(userId, {title, comment} = {}) {
    const res = await api.post(
        `/CurriculumVitae/generate/${userId}`,
        {title: title ?? null, comment: comment ?? null},
        {responseType: "blob"}
    );

    const cd = res.headers?.["content-disposition"] || "";
    const filename = extractFilenameFromContentDisposition(cd) || `CV_${userId}.pdf`;

    const cvId = res.headers?.["x-cv-id"] || null;
    const cvUrl = res.headers?.["x-cv-url"] || null;

    return {blob: res.data, filename, cvId, cvUrl};
}

function extractFilenameFromContentDisposition(contentDisposition) {
    const match = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(contentDisposition || "");
    if (!match?.[1]) return null;

    try {
        return decodeURIComponent(match[1].replace(/"/g, "").trim());
    } catch {
        return match[1].replace(/"/g, "").trim();
    }
}